"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var DefaultService = /** @class */ (function () {
    function DefaultService() {
    }
    /**
     * Get Healthcheck
     * Healthcheck endpoint, returns build info.
     * @returns string Returns build info.
     * @throws ApiError
     */
    DefaultService.getHealthcheck = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/',
        });
    };
    return DefaultService;
}());
exports.DefaultService = DefaultService;
//# sourceMappingURL=DefaultService.js.map